'use client';

import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { startBugsnag, bugsnagEnabled } from '@/lib/bugsnag';

// Start the browser notifier with the React plugin so we can mount its error boundary.
// Runs at module load (client only).
if (bugsnagEnabled) {
  startBugsnag([new BugsnagPluginReact(React)]);
}

function Fallback() {
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <h2>Something went wrong</h2>
      <p>The error has been reported. Try reloading the page.</p>
    </div>
  );
}

export function BugsnagProvider({ children }: { children: React.ReactNode }) {
  if (!bugsnagEnabled) return <>{children}</>;
  const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
  if (!ErrorBoundary) return <>{children}</>;
  return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}
